"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const dictionary_columns_1 = require("../../../composite/evidence-2/dictionary-evidence/dictionary-columns");
const schedule_api_1 = require("../schedule-api");
const jobs_api_1 = require("./jobs-api");
function useColumns() {
    const intl = react_intl_1.useIntl();
    const dictionaryColumns = dictionary_columns_1.useDictionaryColumns();
    return [
        dictionaryColumns.columnOrder,
        dictionaryColumns.columnName,
        dictionaryColumns.columnValidFrom,
        dictionaryColumns.columnValidTo,
        dictionaryColumns.columnActive,
        dictionaryColumns.columnCode,
        {
            datakey: 'timer',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_TIMER',
                defaultMessage: 'Časovač',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'running',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_RUNNING',
                defaultMessage: 'Běží',
            }),
            width: 100,
            CellComponent: table_cells_1.TableCells.BooleanCell,
            sortable: false,
            filterable: false,
        },
        {
            datakey: 'last',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_LAST',
                defaultMessage: 'Poslední spuštění',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.FilterDateCell,
            sortable: false,
            filterable: false,
        },
        {
            datakey: 'next',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_NEXT',
                defaultMessage: 'Příští spuštění',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.FilterDateCell,
            sortable: false,
            filterable: false,
        },
        {
            datakey: 'scriptType',
            sortkey: 'scriptType.name',
            filterkey: 'scriptType.id',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_SCRIPT_TYPE',
                defaultMessage: 'Skriptovací jazyk',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(schedule_api_1.useScriptTypes),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(schedule_api_1.useScriptTypes),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'logAction',
            sortkey: 'logAction.name',
            filterkey: 'logAction.id',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_COLUMN_LOG_ACTION',
                defaultMessage: 'Logování',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(jobs_api_1.useLogActions),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(jobs_api_1.useLogActions),
            sortable: true,
            filterable: true,
        },
        dictionaryColumns.columnCreated,
        dictionaryColumns.columnCreatedBy,
        dictionaryColumns.columnUpdated,
        dictionaryColumns.columnUpdatedBy,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=jobs-columns.js.map